<template>
    <div>
        <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <span 
                    :style="{color: $store.state.authInfo.confirmBox.title == 'message.warning' ? 'orange' : 
                    $store.state.authInfo.confirmBox.title == 'Error' ? 'red' : 'blue'}">
                    {{$t($store.state.authInfo.confirmBox.title)}}
                </span>
                
            </p>
        </header>
        
        <section class="modal-card-body" style="text-align: center;">
                
            <p style="font-weight: bold; font-size: 1.5em;">
                ¿Estás seguro de proceder?
            </p>    
            <p style="font-size: 0.7em;">
                Tenga en cuenta que esta acción es irreversible, puede o no puede recuperar esta información. <br>
                Póngase en contacto con reachus@eventsonline.app para obtener más información.
            </p>
            <div style="height: 20px;">
                    &nbsp;
            </div>
            <div style="width: 100%; text-align: center;">
                <a @click="proceedTheAction" 
                class="button is-medium is-primary" style="text-transform: uppercase;">Si</a>
                <a @click="$store.state.authInfo.confirmBox.show = false" 
                class="button is-medium" style="text-transform: uppercase;">No</a>
            </div>
            
        </section>

        </div>
    </div>
    
</template>

<script>
    export default {
        data() {
            return {
                
            }
        },
        computed: {
            getForwardAction() {
                return this.$store.state.authInfo.confirmBox.followingAction
            }
        },
        methods: {
            proceedTheAction() {
                
                this.$store.dispatch('createOrUpdateData', {
                    target: this.getForwardAction.target,
                    permissions: this.getForwardAction.permissions,
                    targetParameters: this.getForwardAction.targetParameters,
                    targetAction: this.getForwardAction.targetAction // 0 = create, edit = 1, delete = 2
                })

            }
        }
    }
</script>

<style scoped>

    .container {
        width: 30%;
        padding: 20px;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        background-color: #fff; 
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        height: 400px;
    }


/* Change styles for span and cancel button on extra small screens */
@media screen and (max-width: 1024px) {
    .container {
      width: 80%;
    }
    img {
      width: 70%;
    }
}

@media screen and (max-width: 300px) {
    
}

</style>



// WEBPACK FOOTER //
// src/components/Confirm/Index.vue